import React, {Component} from 'react';
import CircularProgressbar from './CircularProgressbar';
import {GetUserNetPromoterScore} from '../api/get/GetUserNetPromoterScore';
import {getUser} from './../firstnetSubscriberOnboarding/GetUser';

// TODO: Need to getrid of if/else conditions for(currentUserJSP), when all legacy jsp's are migrated to React
//Can be worked as part of [Story: 132010], included in Description of the story

class NpsStatus extends Component {
    constructor (props) {
        super(props);
        this.state = {
            statusPoints: 0,
            progressbarText: ' ',
            netPromoterScoreLevel: '',
            currentUserJSP: "",
            totalPoint: 300,
            firstNameChar: '',
            lastNameChar: ''
        }
    }
        
    componentDidMount() {
        if(this.props.currentUser && this.props.currentUser.id){
            this.getUserNetPromoterScoreData();
        } 
        else {
            console.log('getUser call');
            getUser(this.updateUserInfo);
        }
    }

    updateUserInfo = (currentUser) => {
        this.setState({
            currentUserJSP: currentUser
        });
        if(this.state.currentUserJSP) {
            this.getUserNetPromoterScoreData();
        }
    }

    getUserNetPromoterScoreData =() => {
        const  {currentUser} = this.props
        const {currentUserJSP} = this.state
        this.getProgressbarText();
        if(currentUser && currentUser.id){
            return GetUserNetPromoterScore(currentUser.id).then(response => 
                this.setState({
                    statusPoints: response.netPromoterScore,
                    netPromoterScoreLevel : (response.level).toLowerCase()
                })
            );
        } else {
            console.log('else');
            return GetUserNetPromoterScore(currentUserJSP.id).then(response => 
                this.setState({
                    statusPoints: response.netPromoterScore,
                    netPromoterScoreLevel : (response.level).toLowerCase()
                })
            );
        }
    }

    getProgressbarText = () => {
        const  {currentUser} = this.props
        const {currentUserJSP} = this.state
        if(currentUser && currentUser.firstName){
            let firstNameChar = String(currentUser.firstName).charAt(0);
            let lastNameChar = String(currentUser.lastName).charAt(0);
            this.setState({
                firstNameChar: firstNameChar,
                lastNameChar: lastNameChar,
                progressbarText: firstNameChar + lastNameChar
            })
        } else if(currentUserJSP && currentUserJSP.firstName){
            let firstNameChar = String(currentUserJSP.firstName).charAt(0);
            let lastNameChar = String(currentUserJSP.lastName).charAt(0);
            this.setState({
                firstNameChar: firstNameChar,
                lastNameChar: lastNameChar,
                progressbarText: firstNameChar + lastNameChar
            })
        }
    }

    render() {
        const {progressbarText, statusPoints, netPromoterScoreLevel, totalPoint, currentUserJSP} = this.state;
        const  {currentUser} = this.props
        const percentage = (statusPoints/totalPoint)*100
        return(
            <div className="sideNavUserDetailItem">                
                <div className="sidenav---navtext---1AE_f sideNavUserDetailTextItem">
                    <div className="sidenav---navicon---3gCRo npsProgressBar">
                        <CircularProgressbar     
                            percentage={percentage}
                            text={progressbarText}
                        />    
                    </div>
                    { currentUserJSP &&
                        <div className="userName"> {currentUserJSP.firstName} {currentUserJSP.lastName} </div>
                    }
                    { currentUser &&
                        <div className="userName"> {currentUser.firstName} {currentUser.lastName} </div>
                    }                                        
                    <div className="netPromoterScoreLevel"> {netPromoterScoreLevel} </div>
                    <div id = "netPromoterScoreTotal" > ({statusPoints} points) </div>
                </div>
            </div>
        )
    }
}

export default NpsStatus;



// WEBPACK FOOTER //
// ./src/manageMyAccount/NpsStatus.js